import AWSAppSyncClient, { AUTH_TYPE } from "aws-appsync";
import { Auth } from "aws-amplify";
import { GraphqlClient } from "@digitallab/grid-common-lib";

// AppSync-backed GraphqlClient shared by the schema-driven equipment/cluster forms.
// `fetchPolicy` defaults to "network-only"; pass "cache-first" when the same
// master data is read many times in a session (e.g. the audit trail resolving the
// same sites/users/... across every record) so repeated identical queries hit the
// Apollo cache.
export const makeGraphqlClient = (fetchPolicy?: "network-only" | "cache-first"): GraphqlClient =>
  new GraphqlClient(
    new AWSAppSyncClient({
      url: process.env.REACT_APP_AWS_GRAPHQL_ENDPOINT ?? "",
      region: process.env.REACT_APP_AWS_PROJECT_REGION ?? "eu-central-1",
      cacheOptions: {},
      auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
      },
      disableOffline: true,
    }),
    fetchPolicy
  );
